import { PageHeader, Select, Space, Text } from '@app/components'
import { maxMobile } from '@app/styles'
import { Any, PageHeaderProps, SelectProps, SpaceProps, TextProps } from '@app/types'
import styled from 'styled-components'

export const StyledSelect = styled((props: SelectProps<Any>) => <Select {...props} />)`
  && {
    .ant-select-selector {
      background-color: ${(props) => props.theme.color.PRIMARY} !important;
      border: ${(props) => props.theme.color.PRIMARY};
      color: ${(props) => props.theme.color.WHITE};
      height: 40px;
      padding: 0px 30px;
    }
    .ant-select-arrow {
      color: ${(props) => props.theme.color.WHITE};
      margin-right: 10px;
    }
    .ant-select-selection-item {
      color: ${(props) => props.theme.color.WHITE};
      line-height: 38px;
    }
  }
`

export const StyledPageHeader = styled((props: PageHeaderProps) => <PageHeader {...props} />)`
  background-color: ${(props) => props.theme.color?.SECONDARY};
  flex-shrink: 0;
  padding: 15px 50px 15px 24px;
  position: sticky;
  top: 0px;
  z-index: 10;

  @media only screen and (max-width: ${maxMobile}) {
    padding: 6px 25px 6px 16px;
  }

  && {
    .ant-page-header-heading-extra {
      align-items: center;
      display: flex;
    }
    .ant-page-header-heading {
      align-items: center;
      justify-content: space-between;
    }
    .ant-page-header-heading-left {
      display: flex;
      align-items: center;
      margin: 0;
    }
    .ant-page-header-heading-title {
      display: flex !important;
      align-items: center;
      margin: 0 !important;
    }
    .ant-page-header-heading-title > .ant-typography,
    .ant-page-header-heading-title > h1 {
      align-items: center;
      color: ${(props) => props.theme.color.WHITE};
      display: flex !important;
      gap: 16px;
      margin: 0 !important;
    }
  }
`
export const StyledSpace = styled((props: SpaceProps) => <Space {...props} />)`
  flex-wrap: wrap;
`

export const MenuToggleButton = styled.button`
  align-items: center;
  background: transparent;
  border: none;
  color: ${(props) => props.theme.color.WHITE} !important;
  cursor: pointer;
  display: inline-flex;
  flex-shrink: 0;
  font-size: 18px;
  height: 24px;
  justify-content: center;
  line-height: 1;
  margin: 0;
  padding: 0;
  width: 24px;

  &:hover,
  &:focus-visible {
    color: ${(props) => props.theme.color.WHITE} !important;
    opacity: 0.8;
    outline: none;
  }
`

export const StyledText = styled((props: TextProps) => <Text {...props} />)`
  color: ${(props) => props.theme.color.WHITE};
  font-size: 20px;
`
